import axios from 'axios';
import { apiUrl, serverUrl, apiadminUrl, apiUrl2 } from '../../components/Helpers/Config';
import jwtDecode from 'jwt-decode';
import Swal from 'sweetalert2';
import { tokenAuthorize, checkSecondaryLogin, parseJwt } from '../../components/Helpers/Common';

export const LOGIN_SUCCESS = "LOGIN_SUCCESSFUL";
export const LOGIN_GUEST_SUCCESS = "LOGIN_GUEST_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_GOOGLE_FAILED = "LOGIN_GOOGLE_FAILED";
export const LOGOUT_SUCCESSFUL = "LOGOUT_SUCCESSFUL";
export const USER_LOADED = "USER_LOADED";
export const USER_LOADING_FALSE = "USER_LOADING_FALSE";
export const USER_LOAD_AVATAR = "USER_LOAD_AVATAR";
export const USER_LOADING = "USER_LOADING";
export const AUTHENTICATION_ERROR = "AUTHENTICATION_ERROR";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const USER_LOAD_COVER = "USER_LOAD_COVER";
export const USER_LOAD_PINNED = "USER_LOAD_PINNED";
export const GET_USER_THEME = 'GET_USER_THEME';
export const GET_THEME_LOADER = 'GET_THEME_LOADER';
export const GET_USER_DEFAULT_THEME = 'GET_USER_DEFAULT_THEME';
export const USER_PUBLIC_LOADING = "USER_PUBLIC_LOADING";
export const USER_PUBLIC_LOADINGFail = "USER_PUBLIC_LOADINGFail";
export const USER_PUBLIC_LOADED = "USER_PUBLIC_LOADED";
export const AUTHENTICATION_PUBLIC_ERROR = "AUTHENTICATION_PUBLIC_ERROR";
export const AUTHENTICATION_PUBLIC_FAILED = "AUTHENTICATION_PUBLIC_FAILED";
export const MODULES_LOADED = "MODULES_LOADED";
export const GET_IMAGE_POOLS = "GET_IMAGE_POOLS";
export const GET_VBE_LISTS = "GET_VBE_LISTS";
export const GET_SYSTEM_THEMES = "GET_SYSTEM_THEMES";
export const GET_ANALYTICS_LISTS = "GET_ANALYTICS_LISTS";
export const GET_MENU_ITEMS = "GET_MENU_ITEMS";
export const GET_COMMUNITY_SUBMENU_ITEMS = "GET_COMMUNITY_SUBMENU_ITEMS";
// function parseJwt(token) {
//     var base64Url = token.split('.')[1];
//     var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//     var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
//         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//     }).join(''));

//     return JSON.parse(jsonPayload);
// }

export const loginNIE = (token) => {
    return (dispatch, getState) => {
        const tokenjwt = parseJwt(token)
        const data = {
            token: token,
            email: tokenjwt.email
        }

        dispatch({ type: USER_LOADING })
        //localStorage.setItem('themeLoader', true);
        dispatch({ type: GET_THEME_LOADER, payload: true });
        return axios.post(
            serverUrl.Login,
            data
        ).then(resp => {
            if (resp.status === 200) {
                dispatch({ type: LOGIN_SUCCESS, data: resp.data });
                dispatch(loadUser());
                if (resp.data?.themes?.color1 === null) {
                    dispatch({ type: GET_USER_DEFAULT_THEME, payload: "" });
                }
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            checkSecondaryLogin(err?.response?.status);
            dispatch({ type: LOGIN_FAILED, error: ['Invalid Access'] });
        });
    }
}

export const loginGoogle = (googleData) => {
    return (dispatch, getState) => {
        //localStorage.setItem('themeLoader', true);
        dispatch({ type: GET_THEME_LOADER, payload: true });
        dispatch({ type: USER_LOADING })
        const tokenjwt = parseJwt(googleData.tokenId)
        const data = {
            token: googleData.tokenId,
            email: tokenjwt.email
        }
        //refreshGoogleTokenSetup(resp)
        return axios.post(
            serverUrl.LoginGoogle,
            data
        ).then(resp => {
            if (resp.status === 200) {
                return axios.post(
                    serverUrl.Login,
                    { 'token': resp.data.token }
                ).then(resp => {
                    if (resp.status === 200) {
                        dispatch({ type: LOGIN_SUCCESS, data: resp.data });
                        dispatch(loadUser());
                        if (resp.data?.themes?.color1 === null) {
                            dispatch({ type: GET_USER_DEFAULT_THEME, payload: "" });
                        }
                    }
                })
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            checkSecondaryLogin(err?.response?.status);
            dispatch({ type: LOGIN_GOOGLE_FAILED, error: ['Login error'] });
        });
    }

    // const res = await fetch(apiUrl+"login/google", {
    //     method: "POST",
    //     body: JSON.stringify({
    //         token: googleData.tokenId
    //     }),
    //     headers: {
    //         "Content-Type": "application/json"
    //     }
    // })
    // const data = await res.json()

    // if (data.status === 'success') {
    //     // const { history } = this.props;
    //     // history.push("/login/validate/", { token: data.token });
    //     this.props.getLoginToken({'token': data.token});
    // }
}

// export const login = (username, password) => {
//     return (dispatch, getState) => {
//         let headers = {"Content-Type": "application/json"};
//         let data = { username, password };

//         return axios({
//             url: '', //server.Login,
//             method: "POST",
//             validateStatus: (status) => { return status < 500; },
//             headers, data
//         }).then(resp => {
//             if (resp.status === 200) {
//                 dispatch({type: LOGIN_SUCCESS, data: resp.data });
//                 return resp.data;
//             } else if (resp.status === 403 || resp.status === 401) {
//                 dispatch({type: LOGIN_FAILED, error: ['Could not login using your username/password']});
//             } else {
//                 dispatch({type: LOGIN_FAILED, error: [`Could not login (${resp.status})`]});
//             }
//         }).catch(err => {
//             dispatch({type: LOGIN_FAILED, error: ['Login error']});
//         });
//     }
// }

export const loadUser = () => {
    return (dispatch, getState) => {
        if (localStorage?.getItem('dp2_token_access') !== null) {
            dispatch({ type: USER_LOADING });
            return axios.get(serverUrl.LoadUser).then(resp => {
                if (resp.status === 200) {
                    dispatch({
                        type: USER_LOADED,
                        user: resp.data
                    });
                    return resp.data;
                } else if (resp.status >= 400 && resp.status < 500) {
                    dispatch({ type: AUTHENTICATION_ERROR });

                }
            }).catch(err => {
                tokenAuthorize(err?.response?.status);
                dispatch({ type: AUTHENTICATION_ERROR });
                //throw err;
            });
        }
        else {
            dispatch({ type: USER_LOADING_FALSE })
        }
    }
}

export const loadUserPublic = (userCode) => {
    return (dispatch, getState) => {
        dispatch({ type: USER_PUBLIC_LOADING });

        return axios.get(serverUrl.LoadGuestUser + '/' + userCode).then(resp => {
            if (resp.status === 200) {
                dispatch({
                    type: USER_PUBLIC_LOADED,
                    data: {
                        ...jwtDecode(resp.data.token),
                        gid: resp.data.gsuite_user_id,
                        token: resp.data.token,
                    }
                });
            } else if (resp.status >= 400 && resp.status < 500) {
                dispatch({ type: AUTHENTICATION_PUBLIC_ERROR, data: userCode });
                //throw resp.data;
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            dispatch({ type: AUTHENTICATION_PUBLIC_ERROR, data: userCode });
            //throw err;
        });
    }
}

export const setUserPhoto = (profileImg) => {
    return (dispatch) => {
        dispatch({
            type: USER_LOAD_AVATAR,
            payload: {
                photo: profileImg
            },
        });
    }
}

export const setUserCover = (coverImg) => {
    return (dispatch) => {
        dispatch({
            type: USER_LOAD_COVER,
            payload: {
                cover: coverImg
            }
        });
    }
}

export const setUserPinned = (coverImg) => {
    return (dispatch) => {
        dispatch({
            type: USER_LOAD_PINNED,
            payload: {
                pinned_reflection_image: coverImg
            }
        });
    }
}

export const updateProfile = (profileData) => {
    return (dispatch) => {
        dispatch({
            type: UPDATE_PROFILE,
            payload: profileData
        })
    }
}

export const logoutUser = () => {
    return dispatch => {
        axios.post(serverUrl.Logout)
            .then((resp) => {
                if (resp.status == 200) {
                    return dispatch({
                        type: LOGOUT_SUCCESSFUL
                    })
                }
            })
            .catch((error) => {
                tokenAuthorize(error?.response?.status);
                console.log(error)
            });
    }
}


export const getUserTheme = () => {
    return (dispatch) => {
        
        dispatch({ type: GET_THEME_LOADER, payload: true });
        // localStorage.setItem('themeLoader', true);
        return axios
            .get(apiUrl2 + 'user/theme')
            .then((response) => {
                if (response.status == 200) {
                    dispatch({ type: GET_USER_THEME, payload: response.data });
                } else {
                    dispatch({ type: GET_USER_DEFAULT_THEME, payload: "" });
                    dispatch({ type: GET_USER_THEME, payload: "" });
                }
                dispatch({ type: GET_THEME_LOADER, payload: false });
                // localStorage.setItem('themeLoader', false);
            })
            .catch((error) => {
                dispatch({ type: GET_THEME_LOADER, payload: false });
                dispatch({ type: GET_USER_DEFAULT_THEME, payload: "" });
                tokenAuthorize(error?.response?.status);
                // localStorage.setItem('themeLoader', false);
                console.log(error);
            });
    };
};

export const getImagePools = () => {
    return (dispatch) => {
        return axios
            .get(apiUrl + 'images')
            .then((response) => {
                const imageList = response.data?.length > 0 ? response.data : [];
                dispatch({
                    type: GET_IMAGE_POOLS,
                    payload: imageList,
                });
            })
            .catch((error) => {
                tokenAuthorize(error?.response?.status);
                console.log(error);
            });
    };
};


export const getSystemThemes = () => {
    return (dispatch) => {
        return axios
            .get(apiUrl + 'systemthemes')
            .then((response) => {
                const imageList = response.data?.length > 0 ? response.data : [];
                dispatch({
                    type: GET_SYSTEM_THEMES,
                    payload: imageList,
                });
            })
            .catch((error) => {
                tokenAuthorize(error?.response?.status);
                console.log(error);
            });
    };
};


export const loadVBE = (id) => {
    return (dispatch, getState) => {
        //localStorage.setItem('themeLoader', true)
        dispatch({ type: GET_THEME_LOADER, payload: true });
        if (id) {
            return axios.get(
                serverUrl.GetVbeLists2 + "/" + id
            ).then(resp => {
                if (resp.status === 200) {
                    dispatch({ type: GET_VBE_LISTS, payload: resp?.data })
                }
                //localStorage.setItem('themeLoader', false)
                dispatch({ type: GET_THEME_LOADER, payload: false });
            }).catch(err => {
                tokenAuthorize(err?.response?.status);
                console.log(err);
                dispatch({ type: GET_THEME_LOADER, payload: false });
                //localStorage.setItem('themeLoader', false)
            })
        }
    }
}
export const getMenuItems = (id) => {
    return (dispatch, getState) => {
        if (id) {
            return axios.get(
                serverUrl.GetMenus2 + "/" + id
            ).then(resp => {
                if (resp.status === 200) {
                    dispatch({ type: GET_MENU_ITEMS, payload: resp?.data })
                }
            }).catch(err => {
                tokenAuthorize(err?.response?.status);
                console.log(err);
            })
        }
    }
}
// export const loadAnalytics = (id) => {
//     return (dispatch, getState) => {
//         localStorage.setItem('themeLoader', true)
//         return axios.get(
//             serverUrl.GetAnalyticsMenuList + "/" + id
//         ).then(resp => {
//             if (resp.status === 200) {
//                 dispatch({ type: GET_ANALYTICS_LISTS, payload: resp?.data })
//             }
//             localStorage.setItem('themeLoader', false)
//         }).catch(err => {
//             tokenAuthorize(err?.response?.status);
//             localStorage.setItem('themeLoader', false)
//         })
//     }
// }

export const getCommunitySubMenus = (guid) => {
    return (dispatch, getState) => {
        if (guid) {
            return axios.get(
                serverUrl.GetCommunitySubMenu + guid
            ).then(resp => {
                if (resp.status === 200) {
                    dispatch({ type: GET_COMMUNITY_SUBMENU_ITEMS, payload: resp?.data })
                }
            }).catch(err => {
                tokenAuthorize(err?.response?.status);
                console.log(err);
            })
        }
    }
}